<div class="margin-bottom-10">
  <div class="margin-bottom-15" *ngIf="amount">
    <ng-container *ngFor="let item of amount">
      <div class="flex-row">
        <div class="flex-row-lc text-payment-details">
          {{ item.fee_name | titlecase }}
          <span class="fs-10 fw-400" *ngIf="item?.is_tax_inclusive == 1">
            ({{ 'SETTLE_BILL.TAX_INCLUDED' | fallbackTranslate }})
          </span>
        </div>
        <div class="flex-row-rc text-amount">
          {{ Currency }} {{ item?.fee_text }}
        </div>
      </div>

      <hr class="dashed-hr" style="margin: 10px 0px" />
    </ng-container>
    <ng-container *ngIf="details?.billtotal">
      <div class="flex-row">
        <div class="flex-row-lc text-payment-details">
          {{ 'SETTLE_BILL.BILL_TOTAL' | fallbackTranslate }}
        </div>
        <div class="flex-row-rc text-amount">
          {{ Currency }} {{ details?.billtotal_text || details?.billtotal }}
        </div>
      </div>

      <hr class="dashed-hr" style="margin: 10px 0px" />
    </ng-container>

    <ng-container *ngIf="details?.paid">
      <div class="flex-row">
        <div class="flex-row-lc text-payment-details">
          {{ 'SETTLE_BILL.PAID' | fallbackTranslate }}
        </div>
        <div class="flex-row-rc text-amount">
          {{ Currency }} {{ details?.paid_text || details?.paid }}
        </div>
      </div>

      <hr class="dashed-hr" style="margin: 10px 0px" />
    </ng-container>
  </div>
</div>

<div class="amount-tbp-div" *ngIf="details">
  <div class="flex-row">
    <div class="flex-row-lc text-payment-tbp" style="padding-left: 10px">
      {{ 'SETTLE_BILL.AMOUNT_TO_BE_PAID' | fallbackTranslate }}
    </div>
    <div class="flex-row-rc text-amount-tbp" style="padding-right: 10px">
      {{ Currency }} {{ details?.balance_text ||  details?.balance}}
    </div>
  </div>
</div>
